export function toggleBodyScrollDisabled(active: boolean) {
  const method = active ? 'add' : 'remove';

  document
    .body
    .classList
    [method]('scroll-disabled');
};